<div class="app-edit-charger-dialog">
  <div class="header">
    <h3>Edit Station</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="content" #dialogContainer>
    <form class="charger-form" (ngSubmit)="submitForm()" [formGroup]="formGroup">
      <div class="error-message" *ngIf="state() === 'error'">
        <mat-icon>error</mat-icon>
        Something went wrong. Please try again later.
      </div>

      <div class="success-message" *ngIf="state() === 'success'">
        <mat-icon>check_circle</mat-icon>
        Station updated successfully.
      </div>

      <div class="section-label">Basic Information</div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Station name</mat-label>
        <input matInput required formControlName="name">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="3"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Location type</mat-label>
        <mat-select formControlName="locationTypeId">
          <mat-option value="">-- Select --</mat-option>
          <mat-option *ngFor="let type of locationTypes" [value]="type.id.toString()">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Access type</mat-label>
          <mat-select formControlName="accessType">
            <mat-option value="">-- Select --</mat-option>
            <mat-option *ngFor="let type of accessTypes" [value]="type">
              {{ type | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Parking type</mat-label>
          <mat-select formControlName="parkingType">
            <mat-option value="">-- Select --</mat-option>
            <mat-option *ngFor="let type of parkingTypes" [value]="type">
              {{ type | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Hours -->
      <button type="button" class="hours-input" (click)="openHoursDialog()">
        @if (hours?.open24Hours) {
          <span>Hours: Open 24 hours</span>
        } @else if (hours?.dayHours) {
          <span>
            <p *ngFor="let day of daysOfWeek">
              <span>{{ WEEKDAYS[day] }}: </span>
              <span>
                @for (hour of hours.dayHours[day]; track hour) {
                  <span *ngIf="hour?.open && hour?.close">{{ formatTime(hour.open) }}—{{ formatTime(hour.close) }}<span *ngIf="!$last">, </span></span>
                  <span *ngIf="!hour?.open || !hour?.close">Closed</span>
                }
              </span>
            </p>
          </span>
        } @else {
          <span>Hours</span>
        }
        <mat-icon>chevron_right</mat-icon>
      </button>

      <!-- Connectors -->
      <button type="button" class="hours-input" (click)="openConnectorsDialog()">
        <span>
          Connectors
          <span class="connector-count" *ngIf="getConnectorsCount() > 0">({{ getConnectorsCount() }})</span>
        </span>
        <mat-icon>chevron_right</mat-icon>
      </button>

      <div class="section-label">Contact Information</div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Phone number</mat-label>
        <input matInput formControlName="phone">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Website</mat-label>
        <input matInput type="url" formControlName="website">
      </mat-form-field>
    </form>
  </div>

  <mat-divider></mat-divider>

  <div class="actions">
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="submitForm()" [disabled]="state() === 'loading' || formGroup.invalid">
      <mat-spinner *ngIf="state() === 'loading'" diameter="20"></mat-spinner>
      Save Changes
    </button>
  </div>
</div>
